module.exports = __webpack_public_path__ + "img/desk4.af23de6b.png";